export interface ConfigJson {
    BackendUrl: string,
    RedirectUrl: string,
    AuthUrl: string,
    TokenUrl: string,
    RegisterUrl: string,
    OauthClientId: string,
    AiServiceProxyUrl: string,
    PDF_API_URL:string,
    s3Storage_URL: string
}

function requireEnv(key: keyof ImportMetaEnv): string {
    const value = import.meta.env[key];
    if (!value) {
        throw new Error(`Missing required environment variable ${key} - set it in .env (see sample.env) or pass it as a real environment variable.`);
    }
    return value;
}

export class Config {
    static json: ConfigJson = {
        BackendUrl: requireEnv('VITE_BACKEND_URL'),
        RedirectUrl: requireEnv('VITE_REDIRECT_URL'),
        AuthUrl: requireEnv('VITE_AUTH_URL'),
        TokenUrl: requireEnv('VITE_TOKEN_URL'),
        RegisterUrl: requireEnv('VITE_REGISTER_URL'),
        OauthClientId: requireEnv('VITE_OAUTH_CLIENT_ID'),
        AiServiceProxyUrl: requireEnv('VITE_AI_SERVICE_PROXY_URL'),
        PDF_API_URL: requireEnv('VITE_PDF_API_URL'),
        s3Storage_URL: requireEnv('VITE_S3_STORAGE_URL'),
    };
}
